import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Seo from "../components/Seo";
import AuthShell, { GoogleButton } from "../components/auth/AuthShell";
import { Field, inputCls } from "../components/forms/Fields";
import { useAuth, googleLogin } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Client Portal Login" subtitle="Access your goals, consultations and planning reports."
      footer={<>New to Quantora? <Link to="/register" className="font-semibold text-mint-600" data-testid="login-register-link">Create an account</Link></>}>
      <Seo title="Client Login" path="/login" noindex />
      <GoogleButton onClick={googleLogin} />
      <div className="my-6 flex items-center gap-3 text-xs text-slate-400"><span className="h-px flex-1 bg-slate-200" />or with email<span className="h-px flex-1 bg-slate-200" /></div>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field label="Email" id="l-email"><input id="l-email" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" /></Field>
        <Field label="Password" id="l-pass"><input id="l-pass" type="password" required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" /></Field>
        {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
        <div className="flex justify-end"><Link to="/forgot-password" className="text-xs font-medium text-slate-500 hover:text-navy" data-testid="login-forgot-link">Forgot password?</Link></div>
        <button type="submit" disabled={loading} data-testid="login-submit-btn" className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-navy text-sm font-semibold text-white transition-colors hover:bg-navy-700 disabled:opacity-60">
          {loading && <Loader2 size={16} className="animate-spin" />} Sign in
        </button>
      </form>
    </AuthShell>
  );
}
